module.exports = __webpack_public_path__ + "static/media/flutter.a0236109.svg";